<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <v-badge
      slot="activator"
      color="indigo"
      class="badge"
    >
      <span slot="badge">{{ sameRequests.length }}</span>
      <v-icon>info</v-icon>
    </v-badge>
    <v-card>
      <v-data-table
        :headers="sameRequestsHeaders"
        :items="sameRequests"
        hide-actions
        class="elevation-1"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <td>{{ props.item.title }}</td>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer />
        <v-btn
          small
          flat
          @click="menu = false"
        >
          Закрыть
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { getSameRegionRequest } from "../../../backend/shipmentRequestsApi.js";

export default {
  props: ["id"],
  data() {
    return {
      menu: false,
      sameRequests: [],
      sameRequestsHeaders: [
        { text: "Запросы из того же региона", sortable: false },
      ],
    };
  },
  watch: {
    menu(value) {
      if (value) {
        this.loadSameRequests();
      }
    },
  },
  created() {
    this.loadSameRequests();
  },
  methods: {
    async loadSameRequests() {
      if (!this.id) {
        this.sameRequests = [];
      } else {
        this.sameRequests = await getSameRegionRequest(this.id);
      }
    },
  },
};
</script>

<style>
.badge .v-badge__badge {
  margin: 0 10px;
}
</style>
